import JWT from './jwtio';
import OpenID from './openidconnect';
import SAML from './saml';
import WebAuthn from './webauthn';
import Passkeys from './passkeys';
import Backend from './backend';
import Webapp from './webapp';
import Mobile from './mobile';
import SPA from './spa';
import Cloud from './cloud';
import Chevron from './chevron';

export default {
  JWT,
  OpenID,
  SAML,
  WebAuthn,
  Passkeys,
  Backend,
  Webapp,
  Mobile,
  SPA,
  Cloud,
  Chevron,
};
